<template lang="pug">
div(class="container")
  div(class="card")
    header(class="card-header")
      p(class="card-header-title") Organizations
    div(class="card-content")
      b-error(v-if="error" :error="error" class="error")
      div(class="content")
        nx-table(
          ref="nxTable"
          url-add="organization/add"
          url-edit="organization/edit"
          url-fetch="organization/list"
          url-delete="organization/delete"
          :selected-columns="selectedColumns"
          :checkable="true"
          @fillEdit="fill($event)"
        )
          template(#column-merchant="row") {{ row.merchant.displayname }}
          template(#column-gwgThresholdDate="row") {{ getThresholdDate(row.gwgThresholdDate) }}
          template(#form="props")
            div(class="modal-card" style="width: 532px;")
              header(class="modal-card-head")
                p(class="modal-card-title") {{ props.modeAdd ? 'Add organization' : 'Edit organization' }}
              section(class="modal-card-body")
                b-field(label="Merchant")
                  b-select(
                    v-model="formData.merchantId"
                    placeholder="Merchant"
                    required
                  )
                    option(
                      v-for="merchant in merchants"
                      :key="merchant._id"
                      :value="merchant._id") {{ merchant.displayname }}

                b-field(label="Name")
                  b-input(
                    v-model="formData.name"
                    type="string"
                    placeholder="Name"
                    required
                  )

                b-field(label="orgId")
                  b-input(
                    v-model="formData.orgId"
                    type="string"
                    placeholder="orgId"
                    required
                  )

                b-field(label="Config")
                  vue-json-editor(
                    v-model="formData.config"
                    :expanded-on-start="true"
                  )

                b-field(label="gwgThresholdDate")
                  b-datepicker(
                    v-model="gwgThreshold"
                    position="is-top-left"
                    editable
                  )

              footer(class="modal-card-foot")
                b-button(
                  label="Close"
                  icon-left="close"
                  @click="$refs.nxTable.close()"
                )
                b-button(
                  label="Save"
                  icon-left="plus"
                  type="is-primary"
                  @click="$refs.nxTable.save(formData)"
                )
                b-message(v-if="props.error" title="error") {{ props.error }}

    footer(class="card-footer")
</template>

<script>
import moment from 'moment';
import vueJsonEditor from 'vue-json-editor';
import nxTable from '@nx-t/vue-components/vue2/nxTableOld';
import bError from '@nx-t/vue-components/vue2/bError';

export default {
  components: {
    nxTable,
    bError,
    vueJsonEditor,
  },
  data() {
    return {
      selectedColumns: ['name', 'orgId', 'gwgThresholdDate', 'merchant'],
      merchants: [],
      formData: {
        merchantId: null,
        name: '',
        orgId: '',
        config: {},
        gwgThresholdDate: undefined,
      },
      error: null,
    };
  },
  computed: {
    gwgThreshold: {
      get() {
        return this.formData.gwgThresholdDate
          ? new Date(this.formData.gwgThresholdDate)
          : undefined;
      },
      set(value) {
        this.formData.gwgThresholdDate = value;
      },
    },
  },
  created() {
    this.fetchMerchants();
  },
  methods: {
    async fetchMerchants() {
      this.merchants = null;
      this.error = null;

      try {
        const response = await fetch('merchant/list');
        if (!response.ok) {
          const errorData = await response.json();
          throw errorData || { message: 'Unknown Error', status: response.status };
        }

        const data = await response.json();
        this.columns = [];
        this.merchants = data.list;
      } catch (e) {
        this.error = e?.message || e?.toString() || 'Unknown Error';
      }
    },
    fill(editData) {
      this.formData = editData;
      this.formData.merchantId = editData.merchant._id;
      this.formData.gwgThresholdDate = editData.gwgThresholdDate || undefined;
      if (!this.formData.config) {
        this.formData.config = {};
      }
    },
    getThresholdDate(date) {
      return date ? moment(date).format('DD.MM.YYYY') : undefined;
    },
  },
};

</script>
